module.exports = __webpack_public_path__ + "img/V16.3381e5f6.jpg";